<template>
  <div :class="className">{{ $currency(amount, currency) }}</div>
</template>

<script>

export default {
  name: 'WalletTransactionAmount',
  props: ['amount', 'currency'],
  computed: {
    className() {
      if (this.amount > 0) return 'text-success'
      if (this.amount < 0) return 'text-danger'
      return ''
    }
  }
}
</script>
